import { Component, OnInit } from '@angular/core';
import { AutomationsService } from '../../common/_services/automations.service';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { Filter, FilterOperation, HasFilter } from 'src/app/core/jsonapi/filter';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { firstValueFrom } from 'rxjs';
import { LoginService } from '../../login/login.service';
import { CompaniesService } from '../../companies/_services/companies.service';
import { ContractsService } from '../../companies/_services/contracts.service';
import { AutomationsEventsService } from '../../common/_services/automations-events.service';
import { AutomationsCompaniesService } from '../../common/_services/automations-companies.service';
import { DialogService } from 'primeng/dynamicdialog';
import { FilterFieldConfig } from 'src/app/core/filter-panel/filter-field.model';
import { AutomationsDetailComponent } from '../automations-detail/automations-detail.component';

@Component({
    selector: 'app-automations-list',
    templateUrl: './automations-list.component.html',
    styleUrls: ['./automations-list.component.css'],
    host: { class: 'list-page' },
    standalone: false
})
export class AutomationsListComponent implements OnInit {
  
  public automations: any = [];
  public totalRecords: number = 0;
  public loading: boolean = false;
  private lastGridEvent: any;
  public filters: any = {
    name: new Filter(FilterOperation.contains, 'name'),
    //automationEventId: new Filter(FilterOperation.contains, 'automationEvent.name'),
    companyId: new HasFilter('automationCompanies', new Filter(FilterOperation.equals, 'companyId')),
    contractId: new HasFilter('automationCompanies', new Filter(FilterOperation.equals, 'contractId')),
    ids: new Filter(FilterOperation.any, 'id')
  };

  public companyOptions: { label: string; value: any }[] = [];
  public contractOptions: { label: string; value: any }[] = [];
  private lastCompanyId: any = null;
  public fieldsConfig: FilterFieldConfig[] = [
    { filter: this.filters.name, type: 'text', label: 'Nombre', base: true },
    { filter: this.filters.companyId.filter, type: 'select', label: 'Compañía', options: this.companyOptions, filterable: true, base: true },
    { filter: this.filters.contractId.filter, type: 'select', label: 'Contrato', options: this.contractOptions, filterable: true, base: true }
  ];
  public allowWrite: boolean = false;
  public allowDelete: boolean = false;
  public companies: any = [];
  public contracts: any = [];
  public automationsEvents: any = [];

  constructor(
    private automationsService: AutomationsService,
    private router: Router,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    public topbarService: TopbarService,
    private loginService: LoginService,
    private companiesService: CompaniesService,
    private contractsService: ContractsService,
    private automationsCompaniesService: AutomationsCompaniesService,
    private dialogService: DialogService
  ) { }

  ngOnInit(): void {
    
    this.allowWrite = this.loginService.hasPermission('AUTOMATIONS.WRITE') ;
    this.allowDelete = this.loginService.hasPermission('AUTOMATIONS.DELETE') ;

    this.topbarService.setTitle("Automatizaciones");
    if(this.allowWrite){
      this.topbarService.addAction("Nuevo", "pi pi-plus", false, () => {
        this.edit({});
      });
    }
    this.loadCompanies();
    //this.loadAutomatizationEvents();
  }

  async loadData($event: any) {
  
    this.lastGridEvent = $event;
    let params: IParamsCollection = {
      page: { number: $event.first + 1, size: $event.rows },
      include: ['automationEvent']
    }
    if (typeof $event.sortField != "undefined") params.sort = [($event.sortOrder > 0 ? "-" : "") + $event.sortField];

    //creamos filtros
    params.filter = FilterBuilder.fromObject(this.filters).build();

    let response = await firstValueFrom(this.automationsService.all(params));
    this.automations = response.data;
    this.totalRecords = response.meta['total'];
    this.topbarService.setCount(this.totalRecords);
  }

  async loadDataCompany($event: any) {
  
    let params2: IParamsCollection = {filter: FilterBuilder.fromObject(this.filters).build()}

    let response = await firstValueFrom(this.automationsCompaniesService.all(params2));
    let automationsIds = response.data.map(m => m.automationId);

    //Ahora obtenemos las automatizaciones
    if(automationsIds.length == 0){
      this.automations = [];
      this.totalRecords = 0;
      return;
    }else{
      
      this.filters.companyId.filter.value = null;
      this.filters.contractId.filter.value = null;
      this.filters.ids.value = automationsIds;
      this.loadData($event);
    }
  }


/*
  async loadAutomatizationEvents(){
    let params:IParamsCollection = {}    
    let response = await firstValueFrom(this.automationsEventsService.all(params));
    this.automationsEvents = response.data;
  }*/

  async loadCompanies(){
    let params:IParamsCollection = {
      sort: ['name'],
      page: { number: 1, size: 1000 }
    }    
    let response = await firstValueFrom(this.companiesService.all(params));
    this.companies = response.data;
    this.fillOptions(this.companyOptions, response.data);
  }

  private fillOptions(target: { label: string; value: any }[], items: any[]) {
    target.length = 0;
    target.push(...items.map(item => ({ label: item.name, value: item.id })));
  }

  async loadContracts(){
    this.filters.contractId.filter.value = null;
    let filters = {
      companyId: new Filter(FilterOperation.equals, 'companyId')
    };
    filters.companyId.value = this.filters.companyId.filter.value;
    
    let params: IParamsCollection = {
      sort: ['name'],
      page: { number: 1, size: 1000 },
      filter: FilterBuilder.fromObject(filters).build()
    };

    let response = await firstValueFrom(this.contractsService.all(params));
    this.contracts = response.data;
    this.fillOptions(this.contractOptions, response.data);     
    this.loadData(this.lastGridEvent);                  
  }

  clearFilters() {
    this.filters = {};
    this.search();
  }

  search() {
    if (this.filters.companyId.filter.value !== this.lastCompanyId) {
      this.lastCompanyId = this.filters.companyId.filter.value;
      this.loadContracts();
      return;
    }
   /* this.lastGridEvent.first = 0;
    if(this.filters.companyId.value != null){
      this.loadDataCompany(this.lastGridEvent);
    }else{
      
      this.filters.companyId.value = null;
      this.filters.contractId.value = null;*/
      this.loadData(this.lastGridEvent);
    //}
  }

  edit(automation: any) {
    //this.router.navigate(['automations/' + (automation && Object.keys(automation).length > 0 ? automation.id : 0)]);
    const ref = this.dialogService.open(AutomationsDetailComponent, {
      closable: true,
      modal: true,
      data: {
        id: (automation ? automation.id : null)
      },
      header: "Detalles de automatización",
      width: '70%'
    });

    ref.onClose.subscribe(async (data: any) => {
      this.loadData(this.lastGridEvent);
    });
  }
  
  delete(automation: any) {
    if (this.allowDelete) {
      this.confirmationService.confirm({
        message: "¿Está seguro que desea eliminar la automatización?",
        header: "Eliminar",
        acceptLabel: "Aceptar",
        rejectLabel: "Cancelar",
        acceptButtonStyleClass: "p-button-danger",
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.automationsService.delete(automation.id).subscribe({
            next: (data: any) => {
              this.messageService.add({ closable: true, severity: 'success', detail: "Automatización eliminada correctamente" });
              this.loadData(this.lastGridEvent);
            },
            error: (error: any) => {
              this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
            }
          });
        },
        reject: (error: any) => {
          this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
        }
      });
    }
  }

}
